import React from "react";
import { FiPhoneCall, FiHeadphones, FiTrendingUp, FiAlertCircle } from "react-icons/fi";
import "./css/customerservice.css";

const Customerservice = () => {
  const callNow = () => {
    window.location.href = "tel:+919601961116";
  };

  return (
    <div className="cs-elegant">
      {/* HERO */}
      <section className="cs-hero-elegant">
        <h1>Customer Service</h1>
        <p>
          Reliable, responsive and professional support for all Biz Mark
          services.
        </p>

        <button className="cs-btn-primary" onClick={callNow}>
          <FiPhoneCall />
          Call +91 96019 61116
        </button>
      </section>

      {/* SERVICES */}
      <section className="cs-services-elegant">
        <h2>How Can We Help You?</h2>

        <div className="cs-services-grid">
          <div className="cs-service-card">
            <FiHeadphones />
            <h3>Technical Support</h3>
            <p>
              Website issues, performance fixes, updates and technical guidance.
            </p>
          </div>

          <div className="cs-service-card">
            <FiTrendingUp />
            <h3>Marketing Assistance</h3>
            <p>
              SEO, Google Ads, Meta Ads and performance optimisation.
            </p>
          </div>

          <div className="cs-service-card">
            <FiAlertCircle />
            <h3>Urgent Help</h3>
            <p>
              Priority support for critical business or service-related issues.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cs-cta-elegant">
        <h2>Need Immediate Support?</h2>
        <p>Speak directly with our support team.</p>

        <button className="cs-btn-outline" onClick={callNow}>
          <FiPhoneCall />
          Call Support
        </button>
      </section>

      {/* FLOATING CALL */}
      <div className="cs-float-call" onClick={callNow}>
        <FiPhoneCall />
      </div>
    </div>
  );
};

export default Customerservice;